import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-footer.css.lit';
import '../../base/outline-link/outline-link';
import '../../base/outline-container/outline-container';
import '../idb-social-icons/idb-social-icons';
import '../idb-footer-logos/idb-footer-logos';
import { MobileController } from '../../controllers/mobile-controller';
import { classMap } from 'lit/directives/class-map.js';

const socialLinksEn = {
  linkedin: 'https://www.linkedin.com/company/inter-american-development-bank',
  twitter: 'https://twitter.com/the_IDB',
  facebook: 'https://www.facebook.com/IADB.org',
  instagram: 'https://www.instagram.com/el_bid',
  youtube: 'https://www.youtube.com/user/IDB',
  flickr: 'https://www.flickr.com/photos/iadb/albums',
  podcast: 'https://www.spreaker.com/user/14284331',
};

const socialLinksEs = {
  linkedin: 'https://www.linkedin.com/company/inter-american-development-bank',
  twitter: 'https://twitter.com/el_BID',
  facebook: 'https://www.facebook.com/IADB.org',
  instagram: 'https://www.instagram.com/el_bid',
  youtube: 'https://www.youtube.com/user/IDB',
  flickr: 'https://www.flickr.com/photos/iadb/albums',
  podcast: 'https://www.spreaker.com/user/14284331',
};

const socialLinksPt = {
  linkedin: 'https://www.linkedin.com/company/inter-american-development-bank',
  twitter: 'https://twitter.com/bidbr',
  facebook: 'https://www.facebook.com/IADB.org',
  instagram: 'https://www.instagram.com/el_bid',
  youtube: 'https://www.youtube.com/user/IDB',
  flickr: 'https://www.flickr.com/photos/iadb/albums',
  podcast: 'https://www.spreaker.com/user/14284331',
};

const socialLinksFr = {
  linkedin: 'https://www.linkedin.com/company/inter-american-development-bank',
  twitter: 'https://twitter.com/the_IDB',
  facebook: 'https://www.facebook.com/IADB.org',
  instagram: 'https://www.instagram.com/el_bid',
  youtube: 'https://www.youtube.com/user/IDB',
  flickr: 'https://www.flickr.com/photos/iadb/albums',
  podcast: 'https://www.spreaker.com/user/14284331',
};

/**
 * The IdbFooter component
 * @element idb-footer
 * @slot primary - Primary footer menu.
 * @todo update with slots as needed
 */
@customElement('idb-footer')
export class IdbFooter extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  private mobileController = new MobileController(this, 'lg');

  /**
   * The social media url that the icon will link to
   */
  @property({ type: String, attribute: 'language' })
  language: string;

  render(): TemplateResult {
    const wrapperClasses = {
      mobile: this.mobileController.isMobile,
    };

    let socialLinks = socialLinksEn;
    if (this.language == 'es') {
      socialLinks = socialLinksEs;
    } else if (this.language == 'pt' || this.language == 'pt-br') {
      socialLinks = socialLinksPt;
    } else if (this.language == 'fr') {
      socialLinks = socialLinksFr;
    }

    return html`
      <footer class="footer">
        <div class="footer-wave-bg">
          <div class="footer-navigation ${classMap(wrapperClasses)}">
            ${
              !this.mobileController.isMobile
                ? html`
            <outline-container ?x-padding="${!this.mobileController
              .isMobile}" ?y-padding="${!this.mobileController.isMobile}"
            >
              <slot name="primary"></slot>
            </outline-container>`
                : html`<slot name="primary"></slot>`
            }
          </div>
          <div class="footer-bottom--wrapper">
            <outline-container x-padding y-padding container-align="center">
              <div class="footer-bottom--content">
                <div class="footer-social">
                <div class="flex flex-row flex-wrap gap-2">
                  <idb-social-icon-button icon-name="fab-linkedin" url="${
                    socialLinks.linkedin
                  }" link-aria-label="Visit our LinkedIn page" footer="true">
                    </idb-social-icon-button>
                    <idb-social-icon-button icon-name="fab-x-twitter" url="${
                      socialLinks.twitter
                    }" link-aria-label="Visit our Twitter page" footer="true">
                    </idb-social-icon-button>
                    <idb-social-icon-button icon-name="fab-facebook" url="${
                      socialLinks.facebook
                    }" link-aria-label="Visit our Facebook page" footer="true">
                    </idb-social-icon-button>
                    <idb-social-icon-button icon-name="fab-instagram" url="${
                      socialLinks.instagram
                    }" link-aria-label="Visit our Instagram page" footer="true">
                    </idb-social-icon-button>
                    <idb-social-icon-button icon-name="fab-youtube" url="${
                      socialLinks.youtube
                    }" link-aria-label="Visit our Youtube page" footer="true">
                    </idb-social-icon-button>
                    <idb-social-icon-button icon-name="fab-flickr" url="${
                      socialLinks.flickr
                    }" link-aria-label="Visit our Flickr page" footer="true">
                    </idb-social-icon-button>
                    <idb-social-icon-button icon-name="fas-podcast" url="${
                      socialLinks.podcast
                    }" link-aria-label="Listen our Podcasts" footer="true">
                    </idb-social-icon-button>
                  </div>
                </div>
                <div class="footer-logos">
                  <idb-footer-logos language="${
                    this.language
                  }"></idb-footer-logos>
                </div>
              </div>
            </outline-container>
          </div>
        </div>
      </footer>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'idb-footer': IdbFooter;
  }
}
